// @flow

const memberStructuralStyles = {
  toolbarHalf: (theme) => ({
    ...theme.layout.customProps.toolbarHalf
  }),

  toolbar: (theme) => ({
    ...theme.layout.customProps.toolbar
  }),

  capitalize: (theme) => ({
    textTransform: 'capitalize'
  }),

  // Adding any additional utility styles that might be needed
  flexRow: (theme) => ({
    display: 'flex',
    flexDirection: 'row'
  }),

  flexColumn: (theme) => ({
    display: 'flex',
    flexDirection: 'column'
  }),

  alignCenter: (theme) => ({
    display: 'flex',
    alignItems: 'center'
  }),

  justifyBetween: (theme) => ({
    display: 'flex',
    justifyContent: 'space-between'
  })
};

export default memberStructuralStyles;